import { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useExtendedRouter } from '@hooks/next-routing-wrappers';
import { useAuthClient } from '@hooks/common/useAuthClient/useAuthClient';
import { useSwrCreateJobSearchAlert } from '@hooks/useSwrApi/endpoints/job-search-alert';

// Interface
// ******************************************
interface CreateJobSearchAlertProps {
  searchId: string,
  alertExists: boolean,
}


export const useCreateJobSearchAlert = (props: CreateJobSearchAlertProps) => {
  // Destructure props
  const {
    searchId, alertExists,
  } = props;

  // Translation
  const { t } = useTranslation('common');

  // Locale
  const { locale } = useExtendedRouter();

  // Authentication client side
  const { isAuth, redirectToLogin } = useAuthClient();

  // Whether the job search alert is saved.
  // ******************************************************
  const [isSaved, setIsSaved] = useState(alertExists);

  useEffect(() => {
    setIsSaved(alertExists);
  }, [searchId, alertExists]);

  // SWR Mutation: Create job search alert
  // ******************************************************
  const {
    trigger,
    isMutating: isCreatingJobSearchAlert,
  } = useSwrCreateJobSearchAlert(
    searchId,
    locale ?? 'ro',
    () => {
      setIsSaved(true);
    },
    t('job.search.alert.add.success'),
  );

  // Create job search function
  // ******************************************************
  const createJobSearchAlert = () => {
    if (isAuth) {
      void trigger();
    } else {
      redirectToLogin();
    }
  };

  // Return
  // ***********************************************
  return {
    createJobSearchAlert,
    isCreatingJobSearchAlert,
    isSavedJobSearchAlert: isSaved,
  };
};
